import { ThunkAction, configureStore } from "@reduxjs/toolkit";
import { Action, combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { menuReducer } from "./reducers/menuReducer";
import { userReducer } from "./reducers/userReducer";

const rootReducer = combineReducers({
  userReducer,
  menuReducer,
});

export const store = configureStore({
  reducer: persistReducer({ key: "root", storage: storage }, rootReducer),
  devTools: true,
});

export const makeStore = () => store;

type Store = ReturnType<typeof makeStore>;

export type AppDispatch = Store["dispatch"];

export type RootState = ReturnType<Store["getState"]>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
